import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2353927781733926';
export function MetaPixel() {
  useEffect(() => {
    import('react-facebook-pixel').then(x => x.default).then(ReactPixel => {
      ReactPixel.init(PIXEL_ID);
      ReactPixel.pageView();
    }).catch(() => {
      // Fallback if package not available
      const script = document.createElement('script');
      script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${PIXEL_ID}');
          fbq('track', 'PageView');
        `;
      document.head.appendChild(script);
    });
  }, []);
  return null;
}